type DeploymentEnv = 'local' | 'staging' | 'production';

/**
 * Nivea campaign ids per deployment.
 * Keep values here — do not add them to .env files.
 */
const NIVEA_CAMPAIGN_IDS: Record<DeploymentEnv, number | null> = {
  local: 4256,
  staging: 15148,
  production: 17411
};

/** Age-restricted product shown only to users older than 26. */
const NIVEA_AGE_RESTRICTED_PRODUCT_IDS: Record<DeploymentEnv, number | null> = {
  local: 4403,
  staging: 4475,
  production: 3776
};

function getDeploymentEnv(): DeploymentEnv | null {
  const viteEnv =
    typeof import.meta !== 'undefined' &&
    (import.meta as { env?: { VITE_ENV?: string } }).env?.VITE_ENV;
  const env = viteEnv || process.env.NEXT_PUBLIC_ENV;

  if (env === 'localhost' || env === 'local') return 'local';
  if (env === 'staging' || env === 'production') return env;

  return null;
}

function resolveEnvConfig<T>(config: Record<DeploymentEnv, T>): T | null {
  const env = getDeploymentEnv();
  if (!env) return null;
  return config[env] ?? null;
}

/** Nivea campaign id for the current deployment. */
export const NIVEA_CAMPAIGN_ID = resolveEnvConfig(NIVEA_CAMPAIGN_IDS);

/** Nivea product shown only to users older than 26. */
export const NIVEA_AGE_RESTRICTED_PRODUCT_ID = resolveEnvConfig(NIVEA_AGE_RESTRICTED_PRODUCT_IDS);

export function getNiveaCampaignId(): number | null {
  return resolveEnvConfig(NIVEA_CAMPAIGN_IDS);
}

export function getNiveaAgeRestrictedProductId(): number | null {
  return resolveEnvConfig(NIVEA_AGE_RESTRICTED_PRODUCT_IDS);
}

export function isNiveaCampaign(campaignId: number | string | null | undefined): boolean {
  const configuredId = getNiveaCampaignId();
  return configuredId != null && Number(campaignId) === Number(configuredId);
}
